<div class="modal fade show" [ngClass]="{'expanded': isExpanded}" tabindex="-1" aria-labelledby="business-partners-modalLabel"
  aria-hidden="true" [ngStyle]="{'display': 'block'}">
  <div class="modal-dialog modal-90vw">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex w-100">
          <div class="me-2 id flex-fill">
            <h4 class="modal-title mb-0 item-id">Addresses</h4>
          </div>
          <div class="btns-header">
            <button class="expand-modal close" (click)="close()" aria-label="Close">
              <i class="fas fa-times" title="Close Popup"></i>
            </button>
            <button class="expand-modal close" (click)="expandCollapse()">
              <i class="fas ms-2 me-2" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="modal-body pt-0 search-popup-body" [class.expanded-body]="isExpanded">
        <inavista-grid
          [config]="gridConfig"
          [actionIcons]="actionIcons"
          (actionIconClick)="onActionIconClick($event)"
          (hyperlinkClick)="onHyperlinkClick($event)" />
      </div>
    </div>
  </div>
</div>
